<template>
  <v-container grid-list-md pa-0>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion" v-html="textSpanish"></p>
        <p class="palabraResaltada primary--text"></p>
        <p class="ejemplo-bg primary py-3 px-3 radius mt-1 white--text" v-html="textExercise"></p>
      </div>
      <div class="e-ejercicio-ejercicio  pt-0">
        <v-layout  pt-0 column>
          <SubCardFila v-for="(option, index) in options"
          :key="`text-${index}`"
          :respuesta="option"
          @clicked="respuestaSelected"/>
        </v-layout>
      </div>
    </div>
  </v-container>
</template>
<script>
import SubCardFila from './SubCardFila'

export default {
  name: 'practicaSeleccionarFila',
  props: {
    instruccion: {
      type: String,
      default: ''
    },
    textSpanish: {
      type: String,
      default: ''
    },
    textExercise: {
      type: String,
      default: ''
    },
    options: {
      type: Array
    },
    answer: {
      type: String,
      default: ''
    }
  },
  components: {
    SubCardFila
  },
  data() {
    return {
      respuesta: [],
      respuestas: [
        {
          id: 0,
          text: '사어 드릴게요.',
          estado: true,
          selecccionado: false
        },
        {
          id: 1,
          text: '사아 드릴게요.',
          estado: false,
          selecccionado: false
        },
        {
          id: 2,
          text: '사아 드릴게요.',
          estado: false,
          selecccionado: false
        }
      ]
    }
  },
  methods: {
    respuestaSelected (values) {
      if(values.selected){
          this.respuesta.push(values.value)
      } else {
          this.respuesta = this.respuesta.filter( value => value !== values.value )
      }
      const respuestaFinal = {
        answer: this.answer,
        userAnswer: this.respuesta
      }
      this.$emit('clicked', respuestaFinal)
    }
  }
}
</script>
